import { Link } from 'react-router-dom'
import { FileQuestion, Home, ArrowLeft } from 'lucide-react'
import { PageShell } from '@/components/common/PageShell'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

/**
 * 404 Not Found page.
 * Route: /#/not-found (or catch-all)
 */
export function NotFoundPage() {
  return (
    <PageShell>
      <div className="flex items-center justify-center min-h-[60vh] p-6">
        <Card className="max-w-md w-full border-0 shadow-lg">
          <CardContent className="pt-8 pb-8">
            <div className="text-center space-y-6">
              {/* Icon */}
              <div className="mx-auto w-16 h-16 rounded-2xl bg-primary/5 border border-primary/10 flex items-center justify-center">
                <FileQuestion className="h-8 w-8 text-primary/60" />
              </div>

              {/* Message */}
              <div className="space-y-2">
                <h1 className="text-4xl font-bold">404</h1>
                <h2 className="text-xl font-semibold">Page Not Found</h2>
                <p className="text-sm text-muted-foreground">
                  The page you're looking for doesn't exist or has been moved.
                </p>
              </div>

              {/* Actions */}
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Button variant="outline" onClick={() => window.history.back()}>
                  <ArrowLeft className="h-4 w-4 mr-2" />
                  Go Back
                </Button>
                <Button asChild>
                  <Link to="/">
                    <Home className="h-4 w-4 mr-2" />
                    Go to Dashboard
                  </Link>
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </PageShell>
  )
}

export default NotFoundPage
